var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMusicLibrary2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75c-3.65 0-5.75-2.1-5.75-5.75v-4c0-3.6 1.92-4.94 3.53-5.44.65-.21 1.4-.31 2.22-.31h10c.82 0 1.57.11 2.23.32 1.6.49 3.52 1.84 3.52 5.43v4c0 3.65-2.1 5.75-5.75 5.75H7zM5.23 9c-1.67.51-2.48 1.82-2.48 4v4c0 2.86 1.39 4.25 4.25 4.25h10c2.86 0 4.25-1.39 4.25-4.25v-4c0-2.18-.81-3.49-2.47-4-.52-.17-1.12-.25-1.78-.25H7c-.66 0-1.26.08-1.77.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.77 8.99c-.51-.16-1.11-.25-1.77-.25H7c-.66 0-1.26.08-1.77.25a.76.76 0 0 1-.67-.11.767.767 0 0 1-.31-.61V7c0-1.52 1.23-2.75 2.75-2.75h10c1.52 0 2.75 1.23 2.75 2.75v1.28c0 .24-.11.46-.31.61-.13.09-.28.14-.44.14a.62.62 0 0 1-.23-.04zM5.75 7v.34c.39-.06.81-.09 1.25-.09h10c.44 0 .86.03 1.25.09V7c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.75c-.41 0-.75-.34-.75-.75V3.51c0-1.25 1.01-2.26 2.26-2.26h4.98c1.25 0 2.26 1.01 2.26 2.26V5c0 .41-.34.75-.75.75H8zm7.25-1.5v-.74a.76.76 0 0 0-.76-.76H9.51a.76.76 0 0 0-.76.76v.74h6.5zM7 18.14c0-1.14.93-2.07 2.07-2.07 1.14 0 2.07.93 2.07 2.07 0 1.14-.92 2.07-2.07 2.07-1.14 0-2.07-.93-2.07-2.07zm1.5-.01c0 .31.26.57.57.57a.57.57 0 1 0-.57-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65 18.13V12.8c0-.86.54-1.56 1.37-1.79l2.65-.72c.85-.23 1.39-.01 1.69.22.3.23.65.68.65 1.56v5.17c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5.17c0-.25-.05-.35-.07-.37-.02-.01-.14-.03-.38.03l-2.65.72c-.23.06-.26.21-.26.34v5.33c0 .43-.34.76-.75.76s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86 17.25c0-1.14.93-2.07 2.07-2.07 1.14 0 2.07.93 2.07 2.07 0 1.14-.93 2.07-2.07 2.07-1.14 0-2.07-.93-2.07-2.07zm1.5 0c0 .31.26.57.57.57.31 0 .57-.26.57-.57a.57.57 0 1 0-1.14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68 14.55a.75.75 0 0 1 .53-.92l4.85-1.32a.75.75 0 1 1 .39 1.45l-4.851 1.32c-.07.01-.14.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicLibrary2);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-library-2.44394f5632ab06ebd53b65a2d40f7af5.svg";
export { ForwardRef as ReactComponent };